import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import GoogleIcon from "@mui/icons-material/Google";
import InstagramIcon from "@mui/icons-material/Instagram";
import PinterestIcon from "@mui/icons-material/Pinterest";
import { Box, IconButton, Button as MuiButton } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";

import BrandLogo from "../../assets/Icons/BrandLogo.png";
import { theme } from "../../mui-customs/Theme";
import MenuDrawer from "../browse/MenuDrawer";
import Typography from "../Typography";
import TopBarNavButton from "./TopBarNavButton";

const TopBar = () => {
  const [displayMenuDrawer, setDisplayMenuDrawer] = useState(false);
  const router = useRouter();
  return (
    <Box
      component="header"
      sx={{
        position: "fixed",
        top: "0px",
        py: 2,
        px: 3,
        backgroundColor: theme.whiteBg.WBG1,
        width: "100%",
        zIndex: "999",
        display: { xs: "none", md: "block" },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "70rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mx: "auto",
        }}
      >
        <Link href="/">
          <Image
            src={BrandLogo}
            alt="brandlogo"
            height={50}
            width={200}
            style={{ cursor: "pointer" }}
          />
        </Link>
        <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <TopBarNavButton
            label="Home"
            handleNonExpandableClick={() => router.replace("/")}
          />
          <TopBarNavButton
            label="Our Story"
            handleNonExpandableClick={() => {
              window.open(
                "https://morepleaze.com/founder-chef-kyra-bramble",
                "_ blank"
              );
            }}
          />
          <TopBarNavButton
            label="Blog"
            handleNonExpandableClick={() => {
              window.open("https://morepleaze.com/blog/", "_ blank");
            }}
          />
          <TopBarNavButton
            label="Contact"
            handleNonExpandableClick={() => {
              window.open(
                "https://morepleaze.com/contact-more-pleaze/",
                "_ blank"
              );
            }}
          />
        </Box>
        <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              "& button": {
                height: "fit-content",
                p: "6px",
              },
              "& svg": {
                color: theme.brand1[500],
                fontSize: "20px",
              },
              "& svg:hover": {
                color: theme.brand2[400],
              },
            }}
          >
            <Link href="https://www.facebook.com/morepleaze/">
              <a target="_blank">
                <IconButton>
                  <FacebookRoundedIcon />
                </IconButton>
              </a>
            </Link>
            <Link href="https://www.pinterest.com/morepleaze/" target="_blank">
              <a target="_blank">
                <IconButton>
                  <PinterestIcon />
                </IconButton>
              </a>
            </Link>
            <Link
              href="https://www.google.com/maps/place/More+Pleaze/@34.7885114,-119.5690195,4z/data=!3m1!4b1!4m5!3m4!1s0x7eab355b250d26b5:0x261df9f1e897d5dd!8m2!3d34.7885114!4d-119.5690195"
              target="_blank"
            >
              <a target="_blank">
                <IconButton>
                  <GoogleIcon />
                </IconButton>
              </a>
            </Link>
            <Link href="https://www.instagram.com/morepleaze/" target="_blank">
              <a target="_blank">
                <IconButton>
                  <InstagramIcon />
                </IconButton>
              </a>
            </Link>
          </Box>
          <MuiButton
            onClick={() => setDisplayMenuDrawer(true)}
            sx={{
              backgroundColor: theme.brand1[500],
              p: "12px 24px",
              borderRadius: "8px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: theme.brand1[600],
              },
            }}
          >
            <Typography variant="btnDefault" sx={{ color: theme.whiteBg.WBG1 }}>
              Menu
            </Typography>
          </MuiButton>
        </Box>
      </Box>
      <MenuDrawer
        openState={displayMenuDrawer}
        handleClose={() => {
          setDisplayMenuDrawer(false);
        }}
      />
    </Box>
  );
};

export default TopBar;
